import easydropdown from 'easydropdown-a11y'
import '@styles/components/dropdown.css'

const goToPage = (num) => {
  const iframe = document.querySelector('.flipping-book-embed iframe')

  if (iframe) {
    const iframeDocument = iframe.contentDocument || iframe.contentWindow.document

    const pageInput = iframeDocument.querySelector('.pager input[type=text]')

    if (pageInput && pageInput.value !== num) {
      pageInput.value = num

      const enter = new KeyboardEvent('keyup', { keyCode: 13 })
      pageInput.dispatchEvent(enter)
    }
  }
}

const setupDropdown = (el) => {
  const select = el.querySelector('select')

  if (!select) {
    return
  }

  if (select.selectedIndex > 0) {
    select.selectedIndex = 0
  }

  const opts = {
    behavior: {
      openOnFocus: true,
      maxVisibleItems: 10,
      liveUpdates: true,
      useNativeUiOnMobile: false,
    },
    callbacks: {
      onSelect: (value) => goToPage(value),
    },
  }

  easydropdown(select, opts)
}

const setupIssue = () => {
  const keyPointsSelector = document.querySelector('.key-points-selector')
  const embed = document.querySelector('.flipping-book-embed')

  if (embed.dataset.page !== '') {
    setTimeout(() => {
      goToPage(embed.dataset.page)
    }, 2500)
  }

  if (keyPointsSelector) {
    setupDropdown(keyPointsSelector)
  }
}

setupIssue()
